module.exports = __webpack_public_path__ + "img/ai-chat.1880dea7.svg";